import { useState, useEffect, useContext } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
// از همان CSS ساید‌بار پنل کاربر استفاده می‌شود تا ظاهر کاملاً یکسان باشد
import "../../../styles/panel/user/Sidebar.css";
import { AuthContext } from "../../../context/AuthContext";
import whiteLogoFull from "../../../assets/website/white-logo-full.svg";

const BASE = "/panel/pro-majazi";

const Icon = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

// منوی پرومجازی؛ برای اضافه کردن بخش جدید فقط یک آیتم به این آرایه اضافه کنید
const NAV_DATA = [
  {
    type: "link",
    id: "dashboard",
    label: "داشبورد",
    icon: <path d="M3 12l9-8 9 8M6 10.5V20h12v-9.5" />,
  },
];

export default function ProMajaziSidebar() {
  const { logout, user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const currentId = location.pathname.split("/").filter(Boolean).pop();
  const isActive = (id) => currentId === id;

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 1024px)").matches
      : false,
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1024px)");
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("sidebar-locked", isMobile && mobileOpen);
    return () => document.body.classList.remove("sidebar-locked");
  }, [mobileOpen, isMobile]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <button
        className={`mobile-topbar-toggle${mobileOpen ? " is-open" : ""}`}
        aria-label={mobileOpen ? "بستن منو" : "باز کردن منو"}
        aria-expanded={mobileOpen}
        onClick={() => setMobileOpen((v) => !v)}
      >
        <span className="toggle-icon-swap">
          <svg
            className="icon-menu"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 7h16M4 12h16M4 17h16" />
          </svg>
          <svg
            className="icon-back"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M11 6l-6 6 6 6" />
          </svg>
        </span>
      </button>

      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <aside
        className={`sidebar${collapsed ? " collapsed" : ""}${
          mobileOpen ? " mobile-open" : ""
        }`}
        aria-hidden={isMobile && !mobileOpen ? "true" : undefined}
        inert={isMobile && !mobileOpen ? "" : undefined}
      >
        <div className="brand-row">
          <button
            className="brand-mark"
            aria-label={collapsed ? "باز کردن منو" : "جمع کردن منو"}
            onClick={() => setCollapsed((c) => !c)}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>
          <div className="brand-text">
            <div className="brand-name">پرومجازی</div>
            <div className="brand-sub">دکانا بانک جامع فروشگاه های ایران</div>
          </div>
        </div>

        <nav className="nav-scroll">
          {NAV_DATA.map((item) => {
            if (item.type === "link") {
              return (
                <div className="nav-item" key={item.id}>
                  <Link
                    to={`${BASE}/${item.id}`}
                    className={`nav-link${isActive(item.id) ? " active" : ""}`}
                  >
                    <Icon>{item.icon}</Icon>
                    <span className="label">{item.label}</span>
                  </Link>
                  <div className="tooltip">{item.label}</div>
                </div>
              );
            }
            return null;
          })}

          <div className="section-gap" />
          {/* بازگشت به پنل کاربر */}
          <div className="nav-item">
            <Link to="/panel/user/dashboard" className="nav-link">
              <Icon>
                <path d="M19 12H5M11 6l-6 6 6 6" />
              </Icon>
              <span className="label">بازگشت به پنل کاربر</span>
            </Link>
            <div className="tooltip">بازگشت به پنل کاربر</div>
          </div>
        </nav>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="user-avatar">
              <a href="/">
                <img src={whiteLogoFull} alt="دکانا"></img>
              </a>
            </div>
            <div className="user-meta">
              <div className="user-name">
                {user?.first_name} {user?.last_name}
              </div>
            </div>
            <button
              className="logout-btn"
              type="button"
              aria-label="خروج از حساب کاربری"
              onClick={logout}
            >
              <svg
                width="800px"
                height="800px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2 6.5C2 4.01472 4.01472 2 6.5 2H12C14.2091 2 16 3.79086 16 6V7C16 7.55228 15.5523 8 15 8C14.4477 8 14 7.55228 14 7V6C14 4.89543 13.1046 4 12 4H6.5C5.11929 4 4 5.11929 4 6.5V17.5C4 18.8807 5.11929 20 6.5 20H12C13.1046 20 14 19.1046 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 20.2091 14.2091 22 12 22H6.5C4.01472 22 2 19.9853 2 17.5V6.5ZM18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929L19.5858 13L11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11L19.5858 11L18.2929 9.70711C17.9024 9.31658 17.9024 8.68342 18.2929 8.29289Z"
                  fill="#0F1729"
                />
              </svg>
            </button>
          </div>
        </div>
      </aside>

      <main className="content">
        <Outlet />
      </main>
    </>
  );
}
